// Bun inlines env vars matching the pattern in bunfig.toml [serve.static].env
// Note: Only literal process.env.FOO references work, not import.meta.env

export const config = {
  apiBaseUrl: process.env.BUN_PUBLIC_API_BASE_URL ?? "http://localhost:8080",
  messagesEndpoint: "/messages",

  // Auth
  googleClientId: process.env.BUN_PUBLIC_GOOGLE_CLIENT_ID ?? "",
  auth: {
    googleEndpoint: "/auth/google",
    refreshEndpoint: "/auth/refresh",
    logoutEndpoint: "/auth/logout",
  },

  // User
  user: {
    getEndpoint: "/user",
    intervalsicuEndpoint: "/user/intervalsicu",
  },

  // Telegram
  telegram: {
    linkEndpoint: "/user/telegram/link",
  },

  // PostHog Analytics
  posthog: {
    apiKey: process.env.BUN_PUBLIC_POSTHOG_KEY ?? "",
    host: process.env.BUN_PUBLIC_POSTHOG_HOST ?? "https://eu.i.posthog.com",
  },
} as const;

export function getMessagesApiUrl(): string {
  return `${config.apiBaseUrl}${config.messagesEndpoint}`;
}
